import { render, staticRenderFns } from "./OpenProductions.vue?vue&type=template&id=939cffe0&scoped=true&"
import script from "./OpenProductions.vue?vue&type=script&lang=js&"
export * from "./OpenProductions.vue?vue&type=script&lang=js&"
import style0 from "./OpenProductions.vue?vue&type=style&index=0&id=939cffe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939cffe0",
  null
  
)

export default component.exports